import { Component, Event, EventEmitter, h, Prop } from '@stencil/core';
import { MapNavigationEvent } from '@hpfc/fc-frontend-core';

@Component({
  tag: 'fccd-mapbox-pager',
  styleUrl: 'mapbox-pager.scss',
})
export class MapboxPager {
  /* Private Vars */

  /* Props */

  /**
   * Current position in the list of locations
   */
  @Prop() currentPosition: string;

  /**
   * Total number of positions in the list of locations
   */
  @Prop() totalPositions: string;

  /**
   * When minimum, left arrow disabled
   */
  @Prop() isMin: boolean = false;

  /**
   * When maximum, right arrow disabled
   */
  @Prop() isMax: boolean = false;

  /* Event Emitters */

  /**
   * Event triggered by the UI when a user picks a new location
   */
  @Event() mapNavigationEvent: EventEmitter<MapNavigationEvent>;

  /* Events */
  onForwardClick() {
    const data = new MapNavigationEvent('forward', `${this.currentPosition}`, undefined);
    this.mapNavigationEvent.emit(data);
  }

  onBackClick() {
    const data = new MapNavigationEvent('back', `${this.currentPosition}`, undefined);
    this.mapNavigationEvent.emit(data);
  }

  render() {
    const { currentPosition, totalPositions, isMin, isMax } = this;
    const leftClass = isMin ? 'pager-button-disabled' : '';
    const rightClass = isMax ? 'pager-button-disabled' : '';

    return (
      <nav aria-label="Map Pagination">
        <hp5-semantic size-selection="sm">
          <div class="pager">
            <div class="pager__left">
              <div class="pager__text">
                {currentPosition} of {totalPositions}
              </div>
            </div>
            <div class="pager__right">
              <div class="pager__buttons">
                <hp5-icon-button
                  name="system-arrow-left"
                  size-selection="md"
                  icon-size-selection="sm"
                  type="floating"
                  ally-label="Previous Map Location"
                  onClick={this.onBackClick.bind(this)}
                  disabled={isMin}
                  badge-invisible={isMin}
                  class={leftClass}
                />
                <hp5-icon-button
                  name="system-arrow-right"
                  size-selection="md"
                  icon-size-selection="sm"
                  type="floating"
                  ally-label="Next Map Location"
                  onClick={this.onForwardClick.bind(this)}
                  disabled={isMax}
                  badge-invisible={isMax}
                  class={rightClass}
                />
              </div>
            </div>
          </div>
        </hp5-semantic>
      </nav>
    );
  }
}
